module.exports = __webpack_public_path__ + "img/no-result.f0036a8d.jpg";